import React from "react";
import Close from "../../icons/Close";
import { Box, Flex } from "rebass";

import { useEffect } from "react";
import parse360Url from "../../utils/parse360Url";

const Expand360 = ({ onClose, src }) => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://d35cat4w6cwz4j.cloudfront.net/BRIDGE/js/hsl.min.js";
    script.onload = () => {
      window.$("#wrapper-360").hsl({
        url: parse360Url(src),
        autoRotation: true, //Rotazione iniziale
        allowRotation: true, //Abilita/disabilita rotazione con il mouse nascondendo anche la barra di rotazione
        resetOnMouseout: false, //Reset alle impostazioni iniziali al mouseout
        fullScreen: false, //Fullscreen allo startup
        hasButtons: true, //Forza la visualizzazione della barra nel caso di viewer360/closeup
        fixedButtonBar: true,
        withCredentials: false, //Richiesta credenziali per server dietro autenticazione
      });
    };
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <>
      <Flex
        sx={{
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(0, 0, 0, .2)",
          zIndex: 9999,
          position: "fixed",
          top: 0,
          left: 0,
        }}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <Flex
          sx={{
            width: ["100%", "87%"],
            backgroundColor: "white",
            borderRadius: [0, "20px"],
            height: ["100%", "80%"],
            position: "relative",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden",
          }}
        >
          <Flex
            id="wrapper-360"
            sx={{
              width: "100%",
              height: "100%",
            }}
          ></Flex>
          <Box
            onClick={onClose}
            style={{
              position: "absolute",
              top: "20px",
              right: "20px",
              cursor: "pointer",
              zIndex: 1,
            }}
          >
            <Close />
          </Box>
        </Flex>
      </Flex>
    </>
  );
};

export default Expand360;
